import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FiLayers, FiFolder, FiPackage, FiShoppingBag } from "react-icons/fi";
import CategoryManagement from "./CategoryManagement";
import SubCategoryManagement from "./SubCategoryManagement";
import CommonProductManagement from "./CommonProductManagement";
import CommonProductDetail from "./CommonProductDetail";
import PlatformProductManagement from "./PlatformProductManagement";

const TAB_IDS = ["categories", "subCategories", "products", "platformProducts"];

const ProductManagement = () => {
  const location = useLocation();
  const initialTab = location.state?.tab || "categories";
  const [activeTab, setActiveTab] = useState(initialTab);

  // Sync active tab when navigating back with state (e.g. from common product detail)
  useEffect(() => {
    const tabFromState = location.state?.tab;
    if (tabFromState && TAB_IDS.includes(tabFromState)) {
      setActiveTab(tabFromState);
    }
  }, [location.state?.tab, location.key]);

  const tabs = [
    { id: "categories", label: "Categories", icon: FiLayers, component: CategoryManagement },
    { id: "subCategories", label: "Sub-Categories", icon: FiFolder, component: SubCategoryManagement },
    { id: "products", label: "Products", icon: FiPackage, component: CommonProductManagement },
    { id: "platformProducts", label: "Platform Products", icon: FiShoppingBag, component: PlatformProductManagement },
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || CategoryManagement;

  return (
    <div >
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Product Management</h1>
        <p className="text-gray-600">Manage categories, sub-categories, common products, and platform-specific listings</p>
      </div>

      {/* Tabs */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px overflow-x-auto scrollbar-hide scroll-smooth">
            <div className="flex min-w-max">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`
                      flex items-center px-3 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm font-medium border-b-2 transition-colors whitespace-nowrap flex-shrink-0
                      ${activeTab === tab.id
                        ? "border-blue-500 text-blue-600 bg-blue-50 sm:bg-transparent"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 hover:bg-gray-50 sm:hover:bg-transparent"
                      }
                    `}
                  >
                    <Icon size={18} className="mr-1.5 sm:mr-2 flex-shrink-0" />
                    <span className="hidden sm:inline">{tab.label}</span>
                    <span className="sm:hidden">
                      {tab.id === "categories" ? "Categories" :
                       tab.id === "subCategories" ? "Sub-Cat" :
                       tab.id === "products" ? "Products" :
                       tab.id === "platformProducts" ? "Platform" : tab.label}
                    </span>
                  </button>
                );
              })}
            </div>
          </nav>
        </div>
      </div>

      {/* Active Tab Content */}
      <div>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default ProductManagement;

